import { ChangeDetectionStrategy, Component, computed, effect, input, output } from '@angular/core';

import { ColorFamily } from '@ppg/core/models';
import { SortByPipe } from '@ppg/shared/components';

import { ColorFamilySwitcherComponent } from '../color-family-switcher/color-family-switcher.component';

@Component({
  selector: 'ppg-color-family-switchers-grouped',
  standalone: true,
  imports: [ColorFamilySwitcherComponent, SortByPipe],
  templateUrl: './color-family-switchers-grouped.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorFamilySwitchersGroupedComponent {
  readonly colorFamiliesGroupedByType = input.required<Record<string, ColorFamily[]>>();
  readonly colorFamilyTypeKeys = computed(() => Object.keys(this.colorFamiliesGroupedByType()));

  readonly selectedColorFamilyWithType = input.required<{ [x: string]: ColorFamily | undefined } | undefined>();

  readonly customStyle = input<string | undefined>(undefined);

  readonly onDefaultGroupedColorFamilySelected = output<Record<string, ColorFamily>>();
  readonly onGroupedColorFamilySelected = output<Record<string, ColorFamily>>();

  constructor() {
    effect(() => {
      const colorFamiliesGroupedByType = this.colorFamiliesGroupedByType();
      const isSelectedFamilyFound = this.selectedColorFamilyWithType();

      if (
        Object.keys(colorFamiliesGroupedByType).length &&
        (!isSelectedFamilyFound || !Object.values(isSelectedFamilyFound)[0])
      ) {
        const groupKey = Object.keys(colorFamiliesGroupedByType)[0];
        const firstColorFamily = colorFamiliesGroupedByType[groupKey][0];

        this.onDefaultGroupedColorFamilySelected.emit({ [groupKey]: firstColorFamily });
      }
    });
  }

  onColorFamilySelected(familyTypeGroupKey: string, colorFamily: ColorFamily): void {
    this.onGroupedColorFamilySelected.emit({ [familyTypeGroupKey]: colorFamily });
  }

  getSelectedColorFamily(familyTypeGroupKey: string): ColorFamily | undefined {
    if (!this.selectedColorFamilyWithType()) {
      return undefined;
    }

    if (Object.keys(this.selectedColorFamilyWithType()!)[0] === familyTypeGroupKey) {
      return this.selectedColorFamilyWithType()?.[familyTypeGroupKey];
    }

    return undefined;
  }
}
